import { Form, Modal } from 'antd';
import React, { useCallback } from 'react';

import { SalesFunnelFormContent } from '@app/components';
import { CANCEL, PREFIX, SAVE, SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import type {
  FunnelModalForm,
  CreateFunnelModalProps,
} from '@app/pages/SalesFunnels/types';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import {
  useCreateSalesFunnelMutation,
  useGetGlobalFilterFunnelsQuery,
} from '@app/services/rtkQuery/SalesFunnels/api';

const MODAL_TITLE = 'Новая воронка продаж';
const { useForm } = Form;

export const CreateFunnelModal: React.FC<CreateFunnelModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  refetchRegistryListData,
}) => {
  const [form] = useForm();

  const { activeBranchId } = useUserPrint();
  const { showNotification } = useNotification();

  const { refetch: refetchStagesInLeadsService } =
    useGetGlobalFilterFunnelsQuery(
      { ActiveBranchId: activeBranchId },
      { skip: !activeBranchId }
    );

  const [createFunnel, { isLoading }] = useCreateSalesFunnelMutation();

  const handleOk = useCallback(() => {
    form.submit();
  }, [form]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
    form.resetFields();
  }, [form, setIsModalOpen]);

  const handleSaveModal = useCallback(
    async ({
      Name,
      Description,
      UseAutoStageSwitch,
      SyncStagesInExistedLeads,
      ClientServices,
    }: FunnelModalForm) => {
      const getServices = () => {
        if (ClientServices?.length === 1 && ClientServices[0] === -1) {
          return [];
        }
        return ClientServices ?? [];
      };
      try {
        await createFunnel({
          activeBranchId: activeBranchId || 1,
          data: {
            Name: Name ? Name : '',
            Description: Description ? Description : '',
            UseAutoStageSwitch,
            SyncStagesInExistedLeads,
            ClientServices: getServices(),
          },
        }).unwrap();
        await refetchRegistryListData();

        showNotification('Воронка успешно добавлена', SUCCESS);

        form.resetFields();
        setIsModalOpen(false);

        refetchStagesInLeadsService();
      } catch (error) {
        showNotification(error);
      }
    },
    [
      createFunnel,
      activeBranchId,
      refetchRegistryListData,
      showNotification,
      form,
      setIsModalOpen,
      refetchStagesInLeadsService,
    ]
  );

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCancel}
      title={MODAL_TITLE}
      okText={SAVE}
      cancelText={CANCEL}
      onOk={handleOk}
      className={`${PREFIX}create-funnel-modal`}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      <Form form={form} onFinish={handleSaveModal}>
        <SalesFunnelFormContent form={form} />
      </Form>
    </Modal>
  );
};
